module.exports = __webpack_public_path__ + "media/images/icons/thumb-ee6bb0ba279bc4885dc7cd2553b161a6.svg";